/* Zumpo/Card: the focused card of name, create-room and password pages, and
   of dialogs. */
.card {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-24);
  width: min(560px, 100%);
  padding: var(--zumpo-space-32);
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-24);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
}

/* Kind=Panel: a card in a page's column. */
.panel {
  width: 100%;
  gap: var(--zumpo-space-16);
  align-items: flex-start;
}

.title {
  font: var(--zumpo-text-heading);
  letter-spacing: var(--zumpo-text-heading-tracking);
}

/* A title given the focus from code, as a button's ring. */
.title:focus-visible {
  border-radius: var(--zumpo-radius-4);
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.description {
  color: var(--zumpo-muted);
  font: var(--zumpo-text-body);
  letter-spacing: var(--zumpo-text-body-tracking);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--zumpo-space-12);
}
